// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"9cba9163","648":"44b9286f","860":"9cba9163","940":"03cb8c26"}[chunkId] + ".chunk.css";
};